import { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";

import { toast } from "react-toastify";

const FieldExecutiveChangeForm = (props) => {
  const currentDate = new Date().toISOString().slice(0, 10);
  const [date, setDate] = useState(currentDate);
  const [currentExecutiveId, setCurrentExecutiveId] = useState(0);
  const [newExecutiveId, setNewExecutiveId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [newExecutiveData, setNewExecutiveData] = useState([]);
  const [checkedCustomers, setCheckedCustomers] = useState([]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?useCase=Sales&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //  console.log("emp", data.output);
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getCustomer } = useHttp();

  useEffect(() => {
    getCustomer(
      {
        url: `/api/customer/?fieldExecutiveId=${currentExecutiveId}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //   console.log(res);
          setCustomerData(res);
        }
      }
    );

    const filteredData =
      employeeData &&
      employeeData.filter((emp) => emp.userId !== parseInt(currentExecutiveId));

    //console.log(filteredData);
    setNewExecutiveData(filteredData);
  }, [currentExecutiveId]);

  const handleCheckboxChange = (customerId) => {
    setCheckedCustomers((prev) => {
      if (prev.includes(customerId)) {
        return prev.filter((id) => id !== customerId);
      } else {
        return [...prev, customerId];
      }
    });

   // console.log(checkedCustomers);
  };
  const { sendRequest: postFieldExecutiveChange } = useHttp();

  const submitHandler = (event) => {
    event.preventDefault();
  //  console.log(checkedCustomers);

    let customerIds = [];

    customerIds = checkedCustomers.map((customer) => ({
      customerId: customer,
    }));
    //   console.log(customerIds);

    const data = {
      date: moment(new Date().toISOString().slice(0, 10)).format(
        "DD/MM/YYYY"
      ),
      supervisorEmployeeId: parseInt(localStorage.getItem("empId")),
      currentFieldExecutiveId: currentExecutiveId,
      newFieldExecutiveId: newExecutiveId,
      customerList: customerIds,
      remark: "Example remark",
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: moment(new Date().toISOString().slice(0, 10)).format(
        "DD/MM/YYYY hh:mm:ss"
      ),
    };
    console.log(data);

    postFieldExecutiveChange(
        {
          url: "/api/updateFieldExecutive/",
          method: "POST",
          body: data,
        },
        (res) => {
          toast.success(`Field Executive Changed Successfully`);
          props.addForm(false);
         
        }
      );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Change Field Executive</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Date</label>
                        <input
                          type={"date"}
                          id={"date"}
                          required
                          className="form-control"
                          max={currentDate}
                          value={date}
                          onChange={(e) => {
                            setDate(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Current Field Executive </label>
                        <select
                          id="calculationType"
                          className="form-control"
                          required
                          value={currentExecutiveId}
                          onChange={(e) => {
                            setCurrentExecutiveId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option key={x.userId} value={x.userId}>
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>New Field Executive Id</label>

                        <select
                          id="calculationAs"
                          className="form-control"
                          required
                          value={newExecutiveId}
                          onChange={(e) => {
                            setNewExecutiveId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {newExecutiveData &&
                            newExecutiveData.map((x) => (
                              <option key={x.userId} value={x.userId}>
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Customer Code</th>
                          <th>Customer Name </th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerData &&
                          customerData.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  {" "}
                                  <input
                                    type="checkbox"
                                    onChange={() =>
                                      handleCheckboxChange(itm.customerId)
                                    }
                                  />
                                </td>
                                <td>{itm.customerCode}</td>
                                <td>{itm.name}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-md-5"></div>

                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default FieldExecutiveChangeForm;
